class Config {
}
Config.VERIFICATION_EMAILS_COUNT = 10;
Config.VERIFICATION_KEY_LENGTH = 25;
Config.MAX_FILE_COUNT_LIMIT = 2;
Config.ADRESS = "http://localhost:3000";
Config.EMAIL = `
    <div>
      <h3>Już prawie gotowe!</h3>
      Proces tworzenia konta w serwisie Fotohub już prawie się zakończył.
      <br>
      W celu zweryfikowania adresu email przejdź na podany adres:
      <br>
      <a href="__adreess__" >__adreess__</a>
      <br><br>
      Jeśli weryfikacja nie następuje, prosimy o wejście na podany adres z tej samej przeglądarki co podczas rejestracji konta.
    </div>
  `;
Config.FEE_PERCENTAGE = 0.02;
/**
 * Amount in groshes
 */
Config.COST_PER_FULL_IMAGE_DOWNLOAD = 2;
/**
 * Amount in groshes
 */
Config.COST_PER_COLLECTION_VISIT = 3;
export default Config;
